import { Box } from "@strapi/design-system";
import { Tabs } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Nominator from "./Nominator";
import NomineeInfo from "./NomineeInfo";
import Nominees from "./Nominees";
import Secrectariat from "./Secretariat";
import Sidebar from "./layout/Sidebar";
import { useEffect } from "react";

const Profile = ({ lng = "vi" }) => {
  const { t, i18n } = useTranslation();
  const userInfo = useSelector((state) => state.app.userInfo);

  useEffect(() => {
    if (lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng]);

  const nominatorTabItems = [
    {
      key: "1",
      label: `${
        userInfo?.nominator?.is_org == false
          ? t("str_nominator_info")
          : t("str_organization_info")
      }`,
      children: (
        <Nominator
          userInfo={userInfo?.nominator}
          api_path={userInfo?.api_path}
        />
      ),
    },
    {
      key: "2",
      label: `${t("str_nominated_candidate_list")}`,
      children: <Nominees />,
    },
  ];

  if (!userInfo) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div>
        <br />
        <div className="main-wrapper">
          <Sidebar role={userInfo?.role} />

          <div className="main-panel-lg">
            <Box padding={4}>
              {/* Display other user profile information */}
              {userInfo?.role?.type === "nominator" && (
                <Tabs
                  defaultActiveKey="1"
                  items={nominatorTabItems}
                  animated={false}
                />
              )}
              {userInfo?.role?.type === "nominatee" && (
                <NomineeInfo userInfo={userInfo} />
              )}
              {(userInfo?.role?.type === "secretariat" || userInfo?.role?.type === "admin")&& (
                <Secrectariat user={userInfo} />
              )}
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
